import React from 'react';
import { Palette, Hammer, Sparkles } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <Palette className="w-12 h-12 text-amber-600" />,
      title: "צביעת רהיטים",
      description: "שדרוג רהיטים קיימים בצבעים חדשים וטכניקות מתקדמות. אנו מציעים מגוון רחב של גוונים וגימורים המתאימים לכל סגנון עיצוב.",
      features: ["צביעה במברשת", "צביעה בספריי", "גימורים מיוחדים", "צבעים אקולוגיים"]
    },
    {
      icon: <Hammer className="w-12 h-12 text-amber-600" />,
      title: "עבודות עץ",
      description: "תיקון, שיפוץ ושדרוג של רהיטי עץ. אנו מתמחים בטכניקות נגרות מתקדמות ושימור התכונות הטבעיות של העץ.",
      features: ["תיקון נזקים", "החלפת חלקים", "שבחזור רהיטים עתיקים", "הגנה על העץ"]
    },
    {
      icon: <Sparkles className="w-12 h-12 text-amber-600" />,
      title: "חידושים מתקדמים",
      description: "שילוב של טכניקות צביעה ועבודות עץ ליצירת פתרונות עיצובים ייחודיים. אנו מביאים רעיונות חדשניים לכל פרויקט.",
      features: ["עיצובים מותאמים אישית", "טכניקות מעורבות", "שילוב חומרים", "רעיונות חדשניים"]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-900 mb-6">
            השירותים שלנו
          </h2>
          <div className="w-24 h-1 bg-amber-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            אנו מציעים מגוון שירותים מקצועיים לשדרוג והחייאת הרהיטים שלכם
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-amber-50 to-orange-50 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <div className="flex flex-col items-center text-center">
                <div className="mb-6 p-4 bg-white rounded-full shadow-md">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-bold text-amber-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  {service.description}
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center">
                      <span className="w-2 h-2 bg-amber-600 rounded-full mr-2 ml-2"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;